import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { ShiftModel } from '@/http/models'

import { unwrap } from '../unwrap'

export const useShift = (enabled = true) =>
  useQuery({ queryKey: ['shift'], queryFn: () => unwrap(ShiftModel.getCurrent()), enabled })

/** A shift change also changes the register (opened at, float), which the till header shows. */
const useInvalidateShift = () => {
  const client = useQueryClient()
  return () => {
    client.invalidateQueries({ queryKey: ['shift'] })
    client.invalidateQueries({ queryKey: ['register'] })
  }
}

export const useOpenShift = () => {
  const invalidate = useInvalidateShift()
  return useMutation({ mutationFn: (openingBalance: number) => unwrap(ShiftModel.open(openingBalance)), onSuccess: invalidate })
}

export const useRecordCash = () => {
  const invalidate = useInvalidateShift()
  return useMutation({
    mutationFn: (input: { type: 'cash_in' | 'cash_out'; amount: number; remark?: string }) =>
      unwrap(ShiftModel.recordCash(input.type, input.amount, input.remark)),
    onSuccess: invalidate,
  })
}

export const useCloseShift = () => {
  const invalidate = useInvalidateShift()
  return useMutation({ mutationFn: (closingBalance: number) => unwrap(ShiftModel.close(closingBalance)), onSuccess: invalidate })
}
